import React, { useState } from 'react';
import { Download } from '../Download';
import { ButtonActionConfirm } from '../../../components/molecules/Btn/ButtonWrapper';
import { useModalContext } from '../../../components/organisms/ModalDialog/ModalContext';
import { useDelayed } from '../../../hooks/useDelayed';
import LiveRegion from '../../../components/atoms/LiveRegion/LiveRegion';
import { StatusInfoLoading } from '../StatusInfo/StatusInfoLoading';
import { StatusInfoModifier } from '../StatusInfo/partials/StatusInfo';

type FileExportProps = {
  approximateFileSize: number;
  fileNameIncludingExtension: string;
  fileExtension: string;
  fileMimeType: string;
  url: string;
  buttonText: string;
  liveRegionMessage: string;
};

export function FileExportForUseInModal({
  approximateFileSize,
  fileNameIncludingExtension,
  fileExtension,
  fileMimeType,
  url,
  buttonText,
  liveRegionMessage,
}: FileExportProps) {
  const { closeModal } = useModalContext();
  const delayedCloseModal = useDelayed(closeModal);

  const [downloadStarted, setDownloadStarted] = useState(false);

  const close = () => {
    setDownloadStarted(true);
    delayedCloseModal();
  };

  return (
    <div className="file-export-for-use-in-modal">
      <div className="file-export-for-use-in-modal__export-csv-download">
        <Download
          url={url}
          fileName={fileNameIncludingExtension}
          fileExtension={fileExtension}
          mimeType={fileMimeType}
          fileSizeBytes={approximateFileSize}
        />
      </div>
      <div className="file-export-for-use-in-modal__export-csv-button">
        <ButtonActionConfirm text={buttonText} href={url} routing={false} onClick={close}>
          {buttonText}
        </ButtonActionConfirm>
      </div>
      <LiveRegion htmlTag="div" invisible={false} ariaAtomic>
        {downloadStarted && <StatusInfoLoading modifier={StatusInfoModifier.RIGHT} message={liveRegionMessage} />}
      </LiveRegion>
    </div>
  );
}
